import history from '../../../../../history'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectClientId,
  selectClientIsGuest,
} from '../../../../../store/selectors/client'
import {
  setListItemLoading,
  setClickedListItem,
  selectListItemLoading,
  selectClickedListItem,
  setMobileNavIsOpen,
} from '../../../../../store/slices/navbar'
import { routeToHome } from '../../../../../store/selectors/routes'
import { selectCustomerId } from '../../../../../store/selectors/customerProfile'
import { selectActiveItem } from '../../../../../store/selectors/navigation'
import {
  NAVIGATION_DELAY,
  PATH_HELPERS,
} from '../../../../../constants/navigation'
import { Text } from '../../../../../Components'
import { DropdownItem } from '../../../../../Components/shared/Navbar/Dropdown/DropdownItem'
import { SvgWrapper } from '../../../../../Components/shared/Navbar/SvgWrapper'
import { Spinner } from '../../../../../Components/shared/Navbar/Spinner'
import { ListItem } from '../../../../../Components/shared/Navbar/ListItem'
import { PlusSvg } from '../../../../../svgs'
import { HomeownerNavigationComponents } from '../../../../../types/navigation'

export interface SharedAddAHomeLinkProps {
  isMobile?: boolean
}

export const SharedAddAHomeLink = ({ isMobile }: SharedAddAHomeLinkProps) => {
  const dispatch = useDispatch()
  const isGuest = useSelector(selectClientIsGuest)
  const clientId = useSelector(selectClientId)
  const customerProfileId = useSelector(selectCustomerId)

  const loading = useSelector(selectListItemLoading)
  const clickedListItem = useSelector(selectClickedListItem)
  const activeDropdownItem = useSelector(selectActiveItem)

  const handleOnClick = itemId => {
    dispatch(setClickedListItem(itemId))
    dispatch(setListItemLoading(true))

    setTimeout(() => {
      if (isGuest) {
        window.location.assign(PATH_HELPERS.purl.buildPath(customerProfileId))
      } else {
        isMobile && dispatch(setMobileNavIsOpen(false))
        dispatch(setListItemLoading(false))
        history.push(routeToHome(clientId, 'new'))
      }
    }, NAVIGATION_DELAY)
  }

  const renderSvgOrLoading = () => {
    if (
      loading &&
      clickedListItem === HomeownerNavigationComponents.ADD_A_HOME
    ) {
      return <Spinner />
    }

    return (
      <SvgWrapper>
        <PlusSvg />
      </SvgWrapper>
    )
  }

  const Element = isMobile ? ListItem : DropdownItem

  return (
    <Element
      lastItem
      isActive={
        activeDropdownItem === HomeownerNavigationComponents.ADD_A_HOME &&
        !loading
      }
      onClick={() => handleOnClick(HomeownerNavigationComponents.ADD_A_HOME)}
      key={HomeownerNavigationComponents.ADD_A_HOME}
    >
      {renderSvgOrLoading()}
      <Text
        weight='semibold'
        element='span'
        variant='neutralWarm'
        variantCount='700'
      >
        <FormattedMessage
          id='YourHomeLink.addAHome.button'
          defaultMessage='Add a home'
        />
      </Text>
    </Element>
  )
}
